import { Location } from '@angular/common';
import { Component, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TicketSelectionManagerService } from '@tix/event-buyer/state';
import { OrderHoldService } from '@tix/order-hold';
import { TICKET_HOLD_TTL_IN_SECONDS } from '@tix/ticket-hold';
import { environment } from 'apps/purchasing-portal/src/environments/environment';
import * as moment from 'moment';

const ERRORS_ALLOWED_BEFORE_GOING_BACK = environment.production ? 3 : 20;
const SHOW_TIMER_DANGER_AT_TIME_LESS_THAN_IN_SECONDS = environment.production
  ? 2 * 60
  : 14 * 60 + 50;

@Component({
  template: ''
})
export abstract class OrderExpiryTimerComponent implements OnInit, OnDestroy {
  private _interval: number;
  private _errorOccurrences = 0;

  orderTimeRemaining: number = 0;
  orderTimePassed: number = 0;

  get orderTimePercentageRemaining() {
    return 1 - this.orderTimePassed / (TICKET_HOLD_TTL_IN_SECONDS * 1000);
  }

  get orderTimeRemainingFormatted() {
    if (this.orderTimeRemaining <= 0) {
      return '00:00';
    }
    return moment.utc(this.orderTimeRemaining).format('mm:ss');
  }

  get showTimerDanger() {
    if (!this.orderTimePassed) return false;
    return (
      this.orderTimeRemaining <=
      SHOW_TIMER_DANGER_AT_TIME_LESS_THAN_IN_SECONDS * 1000
    );
  }

  constructor(
    private _orderHoldService: OrderHoldService,
    private _snackbar: MatSnackBar,
    private _location: Location,
    private _cdr: ChangeDetectorRef
  ) {}

  ngOnDestroy(): void {
    clearInterval(this._interval);
  }

  ngOnInit(): void {
    this.updateTimeRemaining();
    this._interval = window.setInterval(() => {
      this.updateTimeRemaining();
    }, 1000);
  }

  private updateTimeRemaining() {
    try {
      this.orderTimePassed = this._orderHoldService.getTimeSinceOrderHeld();
      this.orderTimeRemaining =
        TICKET_HOLD_TTL_IN_SECONDS * 1000 - this.orderTimePassed;

      if (this.orderTimeRemaining <= 0) {
        this.orderTimeRemaining = 0;
        clearInterval(this._interval);
        this.backToPurchasingPage();
        return;
      }

      this._cdr.markForCheck();
    } catch (e) {
      console.error(e);
      this._errorOccurrences++;
    }

    if (this._errorOccurrences > ERRORS_ALLOWED_BEFORE_GOING_BACK) {
      this.backToPurchasingPage();
    }
  }

  private backToPurchasingPage() {
    this._snackbar.open(
      'Your tickets have expired, you need to select your tickets again to continue your purchase.'
    );
    // to review:
    window.history.go(-2);
    // this._location.back();
  }
}
